import { useNavigate } from "react-router-dom";
import "./notfound.css";

export default function NotFound() {
    const navigate = useNavigate();

    return (
        <div className="nf-hero">
            <div className="nf-overlay" />
            <div className="nf-content">
                {/* <p className="nf-eyebrow">404</p> */}
                <h1 className="nf-heading">This page is not in session.</h1>
                <p className="nf-sub">The page you're looking for doesn't exist or has been moved.</p>
                <button className="nf-btn" onClick={() => navigate('/public-square')}>
                    Return to Session
                </button>
            </div>
        </div>
    );
}
